import React, {useEffect, useState, useRef, useLayoutEffect} from 'react';
import axios from 'config/axios';
import { IoEyeOutline, IoEyeOffOutline, IoMenu } from 'react-icons/io5';
import { IoMdRadioButtonOn, IoMdRadioButtonOff } from "react-icons/io";
import { FaXmark } from "react-icons/fa6";
import { RiStopCircleLine } from "react-icons/ri";
import {MdOutlineTimerOff} from 'react-icons/md';
import { FaTools, FaRegBookmark, FaBookmark } from "react-icons/fa";
import { RiFilter2Line } from "react-icons/ri";
import { SiZenn } from "react-icons/si";
import { FiHelpCircle } from "react-icons/fi";
import { MULTIPLE_CHOICES, DIGITAL_TIMER_WARNING_TIME } from 'global/constants';
import moment from 'moment';
import Button from 'components/Button2';
import './index.css';
import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";
// import logo from '../../../../assets/images/WellEdLogoWhite.webp';
import Dropdown4 from 'components/Dropdown4';
import Dropdown3 from 'components/Dropdown3';
import DigitalACTDirection from '../DigitalACTDirection';
import { MdClose, MdOpenInFull } from 'react-icons/md';

type DigitalModuleProps = {
    testName: string;
    moduleName: string;
    subject?: string;
    timeLeft?: number;
    isUntimed?: boolean;
    direction?: boolean;
    prompt?: string;
    questions: Array<{
        questionNum: number;
        question: string;
        id: string;
        choices: Array<{
            id: string;
            choice?: string;
            figure?: string;
            isCorrect?: boolean;
        }>;
        passages: {
            id: string;
            introduction?: string;
            passage: string;
            order?: number;
            indices?: Array<{
                startIndex: number;
                endIndex: number;
            }>;
            passageFigures?: Array<{
                figure: {
                    id: string;
                    image: string;
                };
                index: number;
            }>;
        };
        figures: Array<{
            id: string;
            image: string;
            order?: number;
        }>;
    }>;
    selectedReview: string;
    questionNumber: number;
    answers: Array<{
        questionId: string;
        answer?: string;
        marked?: boolean;
        // crossedOut?: {
        //     [key: string]: boolean;
        // };
        crossedOut?: string[];
        masking?: string[];
        annotations: Array<{
            passageId: string;
            startIndex: number;
            endIndex: number;
            annotation: string;
            html?: string;
            preview?: string;
        }>;
        timeSpent?: number;
    }>;
    handleIndexFilters: (filters: { 'All questions': number, 'Flagged': number, 'Answered': number, 'Unanswered': number }) => void;
    closeDirection?: () => void;
    beginTest?: () => void;
    manageExit?: (event: any) => void;
    markQuestion: () => void;
    crossOutChoice?: (choiceId: string) => void;
    maskingChoice?: (choiceId: string) => void;
    saveAnnotation?: (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
    }) => void;
    deleteAnnotation?: (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
    }) => void;
    clearAnnotation?: () => void;
    handleChange: (event: any) => void;
    handleSelect: (event: any) => void;
    handleSaveAndExit: () => void;
    handleDiscardAndExit: () => void;
    handleSubmit: () => void;
    navigateQuestion: (index: number) => void;
};

const INDEXFILTER = {'All questions': 0, 'Flagged': 0, 'Answered': 0, 'Unanswered': 0}
const INITIALTOOLS = ['Line Reader', 'Magnifier'];
const TOOLS = ['Answer Eliminator', 'Answer Masking', 'Highlighter', 'Line Reader', 'Magnifier'];
const MATHTOOLS = ['Answer Eliminator', 'Answer Masking', 'Scientific Calculator', 'Line Reader', 'Magnifier'];

function DigitalACTModule({
    testName,
    moduleName,
    subject,
    timeLeft,
    isUntimed, 
    direction,
    prompt,
    questions,
    questionNumber,
    answers,
    selectedReview,
    closeDirection,
    handleIndexFilters,
    beginTest,
    manageExit,
    markQuestion,
    crossOutChoice,
    maskingChoice,
    saveAnnotation,
    deleteAnnotation,
    clearAnnotation,
    handleChange,
    handleSelect,
    handleSaveAndExit,
    handleDiscardAndExit,
    handleSubmit,
    navigateQuestion
}: DigitalModuleProps) {
    const tools = (questionNumber <= 0)? INITIALTOOLS: ((subject === 'ACT Mathematics') ? MATHTOOLS:TOOLS)
    const [isToolsOpen, setIsToolsOpen] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [hideTimer, setHideTimer] = useState(false);
    const [editAble, setEditAble] = useState(true);
    const [passages, setPassages] = useState(questions[0].passages);
    const [highlighterExplOpen, setHighlighterExplOpen] = useState(false);
    const [exitOpen, setExitOpen] = useState(false);
    const [instructionFlag, setInstructionFlag] = useState(false);
    const [indexOpen, setIndexOpen] = useState(false);
    const [indexFilter, setIndexFilter] = useState(INDEXFILTER);
    const [indexFilterSelected, setIndexFilterSelected] = useState(Object.keys(indexFilter)[0]);
    const [toolsSelected, setToolsSelected] = useState([]);
    const [filteredQuestions, setFilteredQuestions] = useState(questions);
    const [calculator, setCalculator] = useState(null);
    const [highlighting, setHighlighting] = useState<Array<{
        passageId?: string;
        html?: string;
        preview?: string;
    }>>([]);
    const [annotation, setAnnotation] = useState<{
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
    } | null>(null);
    const [fullPassage, setFullPassage] = useState<{
        html?: string;
        preview?: string;
    } | null>(null);
    const indexContainerRef = useRef(null);
    const magnifierIndexContainerRef = useRef(null);
    const questionRefs = useRef([]);
    const magnifierQuestionRefs = useRef([]);
    const passageContainerRef = useRef(null);
    const questionContainerRef = useRef(null);
    const magnifierPassageContainerRef = useRef(null);
    const magnifierQuestionContainerRef = useRef(null);
    const magnifierCalculatorRef = useRef(null);
    const passageRef = useRef(null);
    // control width between testModule and indexContainer
    const [testModuleWidth, setTestModuleWidth] = useState(70); 
    const [indexContainerWidth, setIndexContainerWidth] = useState(30); 
    
    const preventNavigation = (event: BeforeUnloadEvent) => {
        if (timeLeft > 0) {
            event.preventDefault();
            event.returnValue = '';
        }
    }

    // const handleSelectionChange = (_event: Event) => {
    //     const selection = window.getSelection();
    //     const passages = document.getElementsByClassName('digitalModule__passageText');

    //     if (!selection) {
    //         Array.from(passages).forEach(passage => {
    //             passage.classList.remove('digitalModule__passageSelection');
    //         });
    //     }

    //     const {
    //         anchorNode,
    //         anchorOffset,
    //         focusNode,
    //         focusOffset
    //     } = selection;

    //     if (anchorNode !== focusNode || anchorOffset !== focusOffset) {
    //         Array.from(passages).forEach(passage => {
    //             passage.classList.add('digitalModule__passageSelection');
    //         });
    //     }
    //     else {
    //         Array.from(passages).forEach(passage => {
    //             passage.classList.remove('digitalModule__passageSelection');
    //         });
    //     }
    // }

    const dragMove = (element: HTMLElement, header: HTMLElement, parent: HTMLElement, content?: HTMLElement) => {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    
        const dragMouseDown = (event) => {
            event.preventDefault();
            if (element.id!=='magnifierDrag') {
                const element2 = document.getElementById(`${element.id}2`);
                const allElements = document.querySelectorAll('.draggable-element'); // 드래그 가능한 모든 요소들
                allElements.forEach((el) => {
                    const draggableElement = el as HTMLElement;
                    draggableElement.style.zIndex = '2';
                });
                element.style.zIndex = '3'
                element2.style.zIndex = '3'
            }
    
            if (event.type === 'mousedown') {
                pos3 = event.clientX;
                pos4 = event.clientY;
                document.onmousemove = dragElement;
                document.onmouseup = closeDragElement;
            } else if (event.type === 'touchstart') {
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
                document.ontouchmove = dragElement;
                document.ontouchend = closeDragElement;
            }
        };
    
        const dragElement = (event) => {
            event.preventDefault();
    
            if (event.type === 'mousemove') {
                pos1 = pos3 - event.clientX;
                pos2 = pos4 - event.clientY;
                pos3 = event.clientX;
                pos4 = event.clientY;

            } else if (event.type === 'touchmove') {
                pos1 = pos3 - event.touches[0].clientX;
                pos2 = pos4 - event.touches[0].clientY;
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
            }

            // 🔹 부모 요소의 크기 가져오기
            const parentRect = parent.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();

            // 🔹 새로운 위치 계산 (부모 요소 안에 머물도록 제한)
            let newTop = element.offsetTop - pos2;
            let newLeft = element.offsetLeft - pos1;

            newTop = Math.max(1, Math.min(newTop, parentRect.height-0.5 - elementRect.height-0.5));
            newLeft = Math.max(1, Math.min(newLeft, parentRect.width-0.5 - elementRect.width-0.5));

            //🔹 새로운 위치 적용
            element.style.top = `${newTop}px`;
            element.style.left = `${newLeft}px`;

            if (content) {
                // translate 조정
                const translateLeft = newLeft * (2*parent.offsetWidth - element.offsetWidth)/(parent.offsetWidth - element.offsetWidth);
                const translateTop = newTop * (2 * parent.offsetHeight - element.offsetHeight)/(parent.offsetHeight-element.offsetHeight);
                
                content.style.transform = `translate(-${translateLeft}px, -${translateTop}px) scale(2)`
            }
            
            // element'2' drag (drag in magnifier too)
            const element2 = document.getElementById(`${element.id}2`);
            if (element2) {
                element2.style.top = `${newTop}px`;
                element2.style.left = `${newLeft}px`;
            }
        };
    
        const closeDragElement = () => {
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        };
    
        header.onmousedown = (event) => {
            if (event.target instanceof Element && event.target.closest('.digitalACTModule__popupHeaderClose')) {
                return;
            }
            dragMouseDown(event);
        };
    
        header.ontouchstart = (event) => {
            if (event.target instanceof Element && event.target.closest('.digitalACTModule__popupHeaderClose')) {
                return;
            }
            dragMouseDown(event);
        };
    };
    
    // Resize (lineReader, lineReaderTransparent, magnifier screen size control)
    const popupResize = (element: HTMLElement, icon: HTMLElement, parent: HTMLElement, child?: HTMLElement) => {
        let startX = 0, startY = 0, startWidth = 0, startHeight = 0;
        let startElementLeft = 0, startElementTop = 0;
    
        const dragMouseDown = (event) => {
            event.preventDefault();
            startWidth = element.offsetWidth;
            startHeight = element.offsetHeight;
            startElementLeft = element.offsetLeft;
            startElementTop = element.offsetTop;
            
            if (event.type === 'mousedown') {
                startX = event.clientX;
                startY = event.clientY;
                document.onmousemove = dragElement;
                document.onmouseup = closeDragElement;
            } else if (event.type === 'touchstart') {
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
                document.ontouchmove = dragElement;
                document.ontouchend = closeDragElement;
            }    
        };
    
        const dragElement = (event) => {
            event.preventDefault();
    
            let moveX, moveY;
            if (event.type === 'mousemove') {
                moveX = event.clientX - startX + 20;
                moveY = event.clientY - startY + 20;
            } else if (event.type === 'touchmove') {
                moveX = event.touches[0].clientX - startX;
                moveY = event.touches[0].clientY - startY;
            }
    
            // 부모 요소 크기 가져오기
            const parentRect = parent.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();

            // 부모 요소 내에서만 크기 조절 가능하도록 제한
            const maxWidth = parentRect.width - (elementRect.left - parentRect.left);
            const maxHeight = parentRect.height - (elementRect.top - parentRect.top);

            // child의 크기 가져오기 (없으면 기본값)
            const minChildWidth = child ? child.offsetWidth : 120;
            const minChildHeight = child ? child.offsetHeight : 60;

            // 새 크기 계산 (최소값과 최대값 적용)
            let newWidth = Math.max(child?minChildWidth+60:minChildWidth, Math.min(startWidth + moveX, maxWidth));
            let newHeight = Math.max(child?minChildHeight+100:minChildHeight, Math.min(startHeight + moveY, maxHeight));

            // 크기 적용
            element.style.width = `${newWidth-20}px`;
            element.style.height = `${newHeight-20}px`;

            const endX = startElementLeft + newWidth;
            const endY = startElementTop + newHeight;

            // element'2' resize (resize in magnifier too)
            const element2 = document.getElementById(`${element.id}2`);
            if (element2) {
                element2.style.width = `${newWidth-20}px`;
                element2.style.height = `${newHeight-20}px`;
            }
        };
    
        const closeDragElement = () => {
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        };
    
        icon.onmousedown = dragMouseDown;
        icon.ontouchstart = dragMouseDown;
    };

    // Highlight Indexing
    const generateHightlightIndexing = ({id: passageId, indices, passageFigures = []}) => {
        for (let j = 0; j < indices.length; j++){
            const passage = document.getElementById(passageId);
            let passageHTML = '';
            let passagePreview = '';
            const usedFigureIndices = new Set();
            const { startIndex, endIndex } = indices[j];
            let startOffset = startIndex
            let endOffset = endIndex
            let lastIndex = 0;

            for (let i = 0; i < passage.childNodes.length; i++) {
                const childNode = passage.childNodes[i];

                const addMarkTags = (node) => {
                    if (node.outerHTML) {
                        const { innerHTML, outerHTML } = node;
                        const childOffset = outerHTML.indexOf('>') + 1;
    
                        passageHTML += outerHTML.slice(0, childOffset);
    
                        for (let i = 0; i < node.childNodes.length; i++) {
                            const child = node.childNodes[i];
                            addMarkTags(child);
                        }
    
                        passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                    }
                    else {
                        // 이미지 삽입을 위한 passageFigure 검사
                        const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
                        if (currentFigure) {
                            usedFigureIndices.add(currentFigure.figure.index);
                            passageHTML += `
                                <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                            `;                    
                        }
                        const { textContent } = node;
    
                        if (startOffset >= lastIndex && endOffset <= lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startOffset - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                            passagePreview += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        }
                        else if (startOffset >= lastIndex && startOffset < lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startOffset - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startOffset - lastIndex, textContent.length);
                            passageHTML += '</mark>';
                            passagePreview += textContent.slice(startOffset - lastIndex, textContent.length);
                        }
                        else if (endOffset >= lastIndex && endOffset < lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(0, endOffset - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                            passagePreview += textContent.slice(0, endOffset - lastIndex);
                        }
                        else if (startOffset <= lastIndex && endOffset >= lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent;
                            passageHTML += '</mark>';
                            passagePreview += textContent;
                        }
                        else {
                            passageHTML += textContent;
                        }
    
                        lastIndex += textContent.length;
                    }
                }
    
                addMarkTags(childNode);
            }

            const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
            if (currentFigure) {
                passageHTML += `
                    <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                `;                    
            }
            
            setHighlighting(prev => [...(prev || []), { 
                passageId: passageId,
                html: passageHTML, 
                preview: passagePreview 
            }]);
        }

    };

    // fullPassage
    const getPassageWithFigure = ({id: passageId, passageFigures = []}) => {
        const passage = document.getElementById(passageId);
        let passageHTML = '';
        let lastIndex = 0;
        const usedFigureIndices = new Set();

        for (let i = 0; i < passage.childNodes.length; i++) {
            const childNode = passage.childNodes[i];
            // add open tags first while see the text
            const addMarkTags = (node) => {
                if (node.outerHTML) {
                    const { innerHTML, outerHTML } = node;
                    const childOffset = outerHTML.indexOf('>') + 1;

                    passageHTML += outerHTML.slice(0, childOffset);

                    for (let i = 0; i < node.childNodes.length; i++) {
                        const child = node.childNodes[i];
                        addMarkTags(child);
                    }

                    passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                } 
                else {
                    // 이미지 삽입을 위한 passageFigure 검사
                    const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
                    if (currentFigure) {
                        usedFigureIndices.add(currentFigure.figure.index);
                        passageHTML += `
                            <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                        `;                    
                    }
                    const { textContent } = node;
                    passageHTML += textContent;
                    lastIndex += textContent.length;
                }  
            }

            addMarkTags(childNode);
        }

        const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
        if (currentFigure) {
            passageHTML += `
                <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
            `;                    
        }

        setFullPassage({
            html: passageHTML
        });

    };

    // annotation
    const annotationDelete = () => {
        clearAnnotation();
        setAnnotation(null);

        window.getSelection().empty();
    }

    const selectAnnotation = () => {
        const selection = window.getSelection();

        if (!selection) {
            return;
        }

        const {
            anchorNode,
            anchorOffset,
            focusNode,
            focusOffset
        } = selection;

        const passages = document.getElementsByClassName('digitalACTModule__passageTextPassage');
        const passage = Array.from(passages).find(passage => passage.contains(anchorNode) && passage.contains(focusNode));
        if (!passage) {
            return;
        }

        let startOffset = 0;
        let endOffset = 0;

        for (const childNode of Array.from(passage.childNodes)) {
            let childLength = childNode.textContent.length;

            // if (childNode === anchorNode || childNode.contains(anchorNode)) {
            //     startOffset += anchorOffset;
            //     break;
            // } 

            if (childNode === anchorNode) {
                startOffset += anchorOffset;
                break;
            } 

            else if (childNode.contains(anchorNode)) {
                const childText = childNode.textContent;
                const anchorText = anchorNode.textContent;
                const indexInChild = childText.indexOf(anchorText);
                if(indexInChild === -1) {
                    console.error("anchorText not found inside childText");
                    break;
                }
                const lengthBeforeAnchor = indexInChild + anchorOffset;
                startOffset += lengthBeforeAnchor;
                break;
            }
            else {
                startOffset += childLength;
            }
        }

        for (const childNode of Array.from(passage.childNodes)) {
            let childLength = childNode.textContent.length;

            // if (childNode === focusNode || childNode.contains(focusNode)) {
            //     endOffset += focusOffset;
            //     break;
            // } 
            if (childNode === focusNode) {
                endOffset += focusOffset;
                break;
            } 
            else if (childNode.contains(focusNode)) {
                // chileNode.textContent 중에서 anchorNode전까지의 길이에 anchorOffset 더함함 
                const childText = childNode.textContent;
                const focusText = focusNode.textContent;
                const indexInChild = childText.indexOf(focusText);
                if(indexInChild === -1) {
                    console.error("focusText not found inside childText");
                    break;
                }
                const lengthBeforeAnchor = indexInChild + focusOffset;
                endOffset += lengthBeforeAnchor;
                break;
            } 
            else {
                endOffset += childLength;
            }
        }

        if (startOffset > endOffset) {
            const temp = startOffset;
            startOffset = endOffset;
            endOffset = temp;
        }
        else if (startOffset === endOffset) {
            return;
        }

        let passageHTML = '';
        let passagePreview = '';
        let lastIndex = 0;
        for (let i = 0; i < passage.childNodes.length; i++) {
            const childNode = passage.childNodes[i];

            const addMarkTags = (node) => {
                if (node.nodeName === 'IMG') {
                    passageHTML += node.outerHTML;
                }
                else if (node.outerHTML) {
                    const { innerHTML, outerHTML } = node;
                    const childOffset = outerHTML.indexOf('>') + 1;

                    passageHTML += outerHTML.slice(0, childOffset);

                    for (let i = 0; i < node.childNodes.length; i++) {
                        const child = node.childNodes[i];
                        addMarkTags(child);
                    }

                    passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                }
                else {
                    const { textContent } = node;

                    if (startOffset >= lastIndex && endOffset <= lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                    }
                    else if (startOffset >= lastIndex && startOffset < lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, textContent.length);
                        passageHTML += '</mark>';
                        passagePreview += textContent.slice(startOffset - lastIndex, textContent.length);
                    }
                    else if (endOffset >= lastIndex && endOffset < lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(0, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += textContent.slice(0, endOffset - lastIndex);
                    }
                    else if (startOffset <= lastIndex && endOffset >= lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent;
                        passageHTML += '</mark>';
                        passagePreview += textContent;
                    }
                    else {
                        passageHTML += textContent;
                    }

                    lastIndex += textContent.length;
                }
            }

            addMarkTags(childNode);
        }

        // delete annotation if it's overlapped
        let deleteCount = 0
        const relatedAnnotations = answers[questionNumber - 1].annotations.filter(annotation => (
            annotation.passageId === passage.id
        ));

        for (let i = 0; i < relatedAnnotations.length; i++) {
            const annotation = relatedAnnotations[i];
            if ((startOffset <= annotation.startIndex && endOffset > annotation.startIndex) 
                || startOffset < annotation.endIndex && endOffset >= annotation.endIndex) {
                deleteCount+=1;
                deleteAnnotation(annotation);
            } 
        }
        if (deleteCount === 0) {
            setAnnotation({
                passageId: passage.id,
                startIndex: startOffset,
                endIndex: endOffset,
                annotation: '',
                html: passageHTML,
                preview: passagePreview
            });
    
            saveAnnotation({
                passageId: passage.id,
                startIndex: startOffset,
                endIndex: endOffset,
                annotation: '',
                html: passageHTML,
                preview: passagePreview
            });
        }
    }

    // control with between tests and index
    // const handleMouseMove = (event: React.MouseEvent) => {
    //     if (!isDragging.current) return;
        
    //     // Calculate width change based on mouse movement
    //     const dx = event.clientX - startX.current;
    //     const newTestModuleWidth = Math.min(Math.max(0, (testModuleWidth + dx / window.innerWidth * 100)), 100);
    //     const newIndexContainerWidth = 100 - newTestModuleWidth;

    //     setTestModuleWidth(newTestModuleWidth);
    //     setIndexContainerWidth(newIndexContainerWidth);
        
    //     startX.current = event.clientX; // Update the starting X position for dragging
    // };

    // const handleMouseDown = (event: React.MouseEvent) => {
    //     isDragging.current = true;
    //     startX.current = event.clientX;
    //     document.body.style.cursor = 'ew-resize'; // Change cursor to resize
        
    // };

    // const handleMouseUp = () => {
    //     isDragging.current = false;
    //     document.body.style.cursor = 'default'; // Reset cursor
    // };

    // useEffect(()=>{
    //     console.log(testModuleWidth, indexContainerWidth)
    // }, [testModuleWidth, indexContainerWidth])

    // format time in header
    const formatTime = (time: number) => {
        const duration = moment.duration(time, 'seconds');
    
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
    
        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    // katex
    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        const wrappingTexts = document.querySelectorAll<HTMLElement>('.katex-html .base');
        for (let i = 0; i < wrappingTexts.length; i++) {
            if (subject === 'ACT English' || subject === 'ACT Reading' || subject === 'ACT Science') {
                wrappingTexts[i].classList.add('wrap');
            }
            else {
                wrappingTexts[i].classList.remove('wrap');
            }
        }

        const underlines = document.querySelectorAll<HTMLElement>('.katex-html .base .underline');
        for (let i = 0; i < underlines.length; i++) {
            if (underlines[i].querySelector('mark')) {
                continue;
            }
            underlines[i].innerHTML = underlines[i].innerText;
        }

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    const goToQuestion = (index: number) => {
        navigateQuestion(index);

        // let passages = document.getElementById('digitalModule__passages');
        // let question = document.getElementById('digitalModule__questionChoices');

        // if (passages) passages.scrollTop = 0;
        // if (question) question.scrollTop = 0;
    }

    // index part, index part magnifier scroll 
    useEffect(() => {
        const handleScroll = () => {
            const magnifierScollTopValue = indexContainerRef.current?.scrollTop
            if(magnifierIndexContainerRef.current) {
                magnifierIndexContainerRef.current.scrollTo({
                    top: magnifierScollTopValue,
                    // behavior: "smooth"
                });
            }
        }

        if (indexOpen) {
            const container = indexContainerRef.current;
            if (container) {
                container.addEventListener("scroll", handleScroll);
            }
        }

        return () => {
            const container = indexContainerRef.current;
            container?.removeEventListener("scroll", handleScroll);
        }
    }, [indexOpen]);

    // scroll before magnifier selected
    useEffect(() => {
        if (toolsSelected.includes('Magnifier')) {
            if (indexContainerRef.current) {
                const scrollTopValue = indexContainerRef.current.scrollTop;
                magnifierIndexContainerRef.current.scrollTo({ top: scrollTopValue });
            }
            if (passageContainerRef.current) {
                const magnifierScrollTopValue = passageContainerRef.current.scrollTop;
                magnifierPassageContainerRef.current.scrollTo({ top: magnifierScrollTopValue });
            }
        }
    }, [toolsSelected]);

    useEffect(() => {
        if (questionNumber >= 0 && questionRefs.current[questionNumber]) {
            // indexContainerRef 내에서 해당 questionNumber에 해당하는 indexBox로 스크롤
            if (indexContainerRef.current) {
                const scrollTopValue = questionRefs.current[questionNumber].offsetTop - indexContainerRef.current.offsetTop
                indexContainerRef.current.scrollTo({
                    top: scrollTopValue,
                    behavior: "smooth"
                });
            }
        } 
    }, [questionNumber, indexOpen, filteredQuestions]);

    // passage scroll, passage magnifier scroll (according to the highliting index)
    useLayoutEffect(() => {
        const passageHandleScroll = () => {
            const magnifierScollTopValue = passageContainerRef.current?.scrollTop
            if (magnifierPassageContainerRef.current) {
                magnifierPassageContainerRef.current.scrollTo({
                    top: magnifierScollTopValue
                    // behavior: "smooth", 
                });
            }
        }

        const questionHandleScroll = () => {
            const magnifierQuestionScollTopValue = questionContainerRef.current?.scrollTop
            if (magnifierQuestionContainerRef.current) {
                magnifierQuestionContainerRef.current.scrollTo({
                    top: magnifierQuestionScollTopValue
                    // behavior: "smooth", 
                });
            }
        }
    
        const passageContainer = passageContainerRef.current;
        const questionContainer = questionContainerRef.current;
        if (passageContainer) {
            passageContainer.addEventListener("scroll", passageHandleScroll);
        }
        if (questionContainer) {
            questionContainer.addEventListener("scroll", questionHandleScroll); 
        }
    
        return () => {
            passageContainer?.removeEventListener("scroll", passageHandleScroll);
            questionContainer?.removeEventListener("scroll", questionHandleScroll);
        };
    }, [questionNumber]);

    useLayoutEffect(() => {
        if (questionNumber > 0 && highlighting.length > 0) {
            const passageId = highlighting[0].passageId;
            const passage = document.getElementById(`highlighting ${passageId}`);
            // highlighting 여러개일 경우 첫 번째 
            if (passage) {
                let firstHighlight = passage.querySelector("mark"); // 첫 번째 mark 태그 찾기
                let offset = 0;
                while (firstHighlight !== passage) {
                    offset = firstHighlight.offsetTop;
                    firstHighlight = firstHighlight.parentElement;
                }
                if (firstHighlight && passageContainerRef.current) {
                    passageContainerRef.current.scrollTo({
                        top: firstHighlight? offset - passageContainerRef.current.offsetTop: 0,
                        behavior: "smooth", 
                    });
                }
            }
        }
    }, [highlighting]);

    // index questions filtering
    useEffect(() => {
        switch(indexFilterSelected) {
            case 'All questions':
                setFilteredQuestions(questions);
                break;
            case 'Flagged':
                setFilteredQuestions(questions.filter(q => 
                    answers.find(a => a.questionId === q.id && a.marked)
                ));
                break;            
            case 'Answered':
                setFilteredQuestions(questions.filter(q => 
                    answers.find(a => a.questionId === q.id && a.answer !=='' && a.answer!==null)
                ));
                break;
            case 'Unanswered':
                setFilteredQuestions(questions.filter(q => 
                    answers.find(a => a.questionId === q.id && (a.answer ==='' || a.answer===null))
                ));
                break;
        }
    }, [indexFilterSelected, answers]);

    const getFilteredQuestionsCount = (filter:string) => {
        switch (filter) {
            case 'All questions':
                return questions.length;  // 모든 질문의 갯수
            case 'Flagged':
                return instructionFlag? questions.filter(q => answers.find(a => a.questionId === q.id && a.marked)).length+1: questions.filter(q => answers.find(a => a.questionId === q.id && a.marked)).length;  // 'marked'가 True인 질문
            case 'Answered':
                return questions.filter(q => answers.find(a => a.questionId === q.id && a.answer !== '' && a.answer !== null)).length;  // 답변이 있는 질문
            case 'Unanswered':
                return questions.filter(q => answers.find(a => a.questionId === q.id && (a.answer === '' || a.answer === null))).length;  // 답변이 없는 질문
            default:
                return 0;
        }
    };

    useEffect(() => {
        const updatedIndexFilter = {
            'All questions': getFilteredQuestionsCount('All questions'),
            'Flagged': getFilteredQuestionsCount('Flagged'),
            'Answered': getFilteredQuestionsCount('Answered'),
            'Unanswered': getFilteredQuestionsCount('Unanswered')
        };
        handleIndexFilters(updatedIndexFilter);
        setIndexFilter(updatedIndexFilter); // indexFilter 객체를 업데이트
    }, [answers, instructionFlag]);

    // Tools
    const handleTools = (tool:string) => {
        if (toolsSelected.includes(tool)) {
            setToolsSelected(prevTools => prevTools.filter(t => t !== tool));
        } else {
            if (tool === 'Magnifier') {
                setToolsSelected(prevTools => [...prevTools.filter(t => t !== "Scientific Calculator"), tool]);
            } else if (tool === 'Scientific Calculator') {
                setToolsSelected(prevTools => [...prevTools.filter(t => t !== "Magnifier"), tool]);
            } else {
                setToolsSelected(prevTools => [...prevTools, tool]);
            }
        }

        if (tool ==='Highlighter') {
            setHighlighterExplOpen(false);
        }
    };

    // calculator
    useEffect(() => {
        if (toolsSelected.includes('Scientific Calculator')) {
            calculator.focusFirstExpression();
        }
        // if (calculator && magnifierCalculatorRef.current) {
        //     const magnifierEl = magnifierCalculatorRef.current;

        //     // 두 번째 계산기를 생성할 때 첫 번째 계산기와 동일한 상태를 반영
        //     const secondCalcInstance = Desmos.GraphingCalculator(magnifierEl);
            
        //     // 첫 번째 계산기의 모든 상태를 두 번째 계산기에 반영
        //     secondCalcInstance.setState(calculator.getState());
        // }
    }, [calculator]);

    useEffect(()=>{
        setIndexOpen(true);
        setIndexFilterSelected(selectedReview);
    }, [selectedReview]);

    useEffect(() => {
        setIndexOpen(false);
        setIndexFilterSelected(Object.keys(indexFilter)[0])
        const calculatorEl = document.getElementById('calculator');
        if (calculatorEl) {
            setCalculator(Desmos.GraphingCalculator(calculatorEl, {
                notes: false,
                folders: false,
                images: false,
                links: false
            }));
        } else {
            console.error("Calculator elements not found!");
        }
        // pop up
        const calculatorDragEl = document.getElementById('calculatorDrag');
        const calculatorHeaderEl = document.getElementById('calculatorHeader');
        const calculatorParentEl = document.getElementById('digitalACTModule__testModule');
        if (calculatorDragEl && calculatorHeaderEl && calculatorParentEl) {
            dragMove(calculatorDragEl, calculatorHeaderEl, calculatorParentEl);
        }

        const LineReaderDragEl = document.getElementById('lineReaderDrag');
        const LineReaderHeaderEl = document.getElementById('lineReaderHeader');
        const LineReaderParentEl = document.getElementById('digitalACTModule__testModule');
        if (LineReaderDragEl && LineReaderHeaderEl && LineReaderParentEl) {
            dragMove(LineReaderDragEl, LineReaderHeaderEl, LineReaderParentEl);
        }

        const HighlighterDragEl = document.getElementById('highlighterDrag');
        const HighlighterHeaderEl = document.getElementById('highlighterHeader');
        const HighlighterParentEl = document.getElementById('digitalACTModule__testModule') as HTMLElement;
        if (HighlighterDragEl && HighlighterHeaderEl && HighlighterParentEl) {
            dragMove(HighlighterDragEl, HighlighterHeaderEl, HighlighterParentEl);
        }
        
        const MaginifierDragEl = document.getElementById('magnifierDrag');
        const MaginifierHeaderEl = document.getElementById('magnifierHeader');
        const MagnifierParentEl = document.getElementById('digitalACTModule');
        const MagnifierContentEl = document.getElementById('digitalACTModule__popupMagnifierContent'); // magnified part
        if (MaginifierDragEl && MaginifierHeaderEl && MagnifierParentEl && MagnifierContentEl) {
            dragMove(MaginifierDragEl, MaginifierHeaderEl, MagnifierParentEl, MagnifierContentEl);
        }
        // line Reader popup resizing
        const lineReaderResizeEl = document.getElementById('lineReaderDrag');
        const lineReaderResizeIconEl = document.getElementById('digitalACTModule__lineReaderResize');
        const lineReaderResizeParentEl = document.getElementById('digitalACTModule__testModule');
        const lineReaderResizeChildEl = document.getElementById('digitalACTModule__popuplineReaderContent');
        if (lineReaderResizeEl && lineReaderResizeIconEl && lineReaderResizeParentEl && lineReaderResizeChildEl) {
            popupResize(lineReaderResizeEl, lineReaderResizeIconEl, lineReaderResizeParentEl, lineReaderResizeChildEl);
        }

        // line Reader transparent resizing
        const transparentResizeEl = document.getElementById('digitalACTModule__popuplineReaderContent');
        const transparentResizeIconEl = document.getElementById('digitalACTModule__lineReaderTransparentResize');
        const transparentResizeParentEl = document.getElementById('lineReaderDrag');
        if (transparentResizeEl && transparentResizeIconEl && transparentResizeParentEl) {
            popupResize(transparentResizeEl, transparentResizeIconEl, transparentResizeParentEl);
        }
        // magnifier resizing
        const magnifierResizeEl = document.getElementById('magnifierDrag');
        const magnifierResizeIconEl = document.getElementById('digitalACTModule__magnifierResize');
        const magnifierResizeParentEl = document.getElementById('digitalACTModule');
        if (magnifierResizeEl && magnifierResizeIconEl && magnifierResizeParentEl) {
            popupResize(magnifierResizeEl, magnifierResizeIconEl, magnifierResizeParentEl);
        }

        window.addEventListener('beforeunload', preventNavigation);
        // document.addEventListener('selectionchange', handleSelectionChange);

        return () => {
            window.removeEventListener('beforeunload', preventNavigation);
            // document.removeEventListener('selectionchange', handleSelectionChange);
        };
    }, []);

    useEffect(() => {
        renderKatex();
    }, [subject, answers, filteredQuestions, indexOpen, direction]);

    useEffect(()=>{
        if (questionNumber > 0) {
            // const p = document.getElementById(questions[questionNumber-1]?.passages.id);
            // if (p) {
            //     p.innerHTML = questions[questionNumber-1]?.passages.passage
            // }
            renderKatex();

            closeDirection();
            setHighlighting([]);
            setFullPassage(null);
            const passageData = questions[questionNumber - 1]?.passages;
            if (passageData) {
                const { id, indices, passageFigures } = questions[questionNumber-1].passages
                getPassageWithFigure({ id, passageFigures });
                if (indices) generateHightlightIndexing({ id, indices, passageFigures });  
            }
        }
    }, [questionNumber]);

    return (
        <div id='digitalACTModule' className='digitalACTModule'>
            {/* Magnifier*/}
            <div id='magnifierDrag' className={toolsSelected.includes('Magnifier')
                ? 'digitalACTModule__popup--magnifier'
                : 'digitalACTModule__popup--hidden'
            }>
                <div id='magnifierHeader' className='digitalACTModule__popupHeader'>
                    <h3 className='digitalACTModule__popupHeaderText'>Magnifier</h3>
                    <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Magnifier')} />
                </div>
                <div className='digitalACTModule__popupMagnifier'>
                    <div id='digitalACTModule__popupMagnifierContent' className='digitalACTModule__popupMagnifierContent'>
                        <div className='digitalACTModule'>
                            {/* header */}
                            <div className='digitalACTModule__header'>
                                {/* header - left */}
                                <div className='digitalACTModule__title'>
                                    <div className='digitalACTModule__titleContent'>{testName}</div>
                                    {/* <img 
                                        className='digitalACTModule__logo'
                                        src={logo} 
                                    /> */}
                                </div>
                                {/* header - middle */}
                                <div className='digitalACTModule__actionGroup'>
                                    <Dropdown3 
                                        icon={<FaTools />}
                                        data={tools} 
                                        selectedItems={toolsSelected}
                                        onSelect={(value)=> handleTools(value)}
                                        value='TOOLS'
                                        // disabled={questionNumber <= 0}
                                        isOpen={isToolsOpen}
                                    />
                                    {/* <Dropdown3
                                        icon={<FaTools />}
                                        data={tools} 
                                        selectedItems={toolsSelected}
                                        onSelect={(value)=> handleTools(value)}
                                        value='CONTRAST'
                                        isOpen={isToolsOpen}
                                        setIsOpen={setIsToolsOpen}
                                    /> */}
                                </div>
                                {/* header - right */}
                                <div className='digitalACTModule__testInfoGroup'>
                                    <div className='digitalACTModule__answerInfo'>
                                        <div className='digitalACTModule__answerTitle'>ANSWERED</div>
                                        <div className='digitalACTModule__answerContent'>{indexFilter['Answered']} out of {questions.length}</div>
                                    </div>
                                    {!isUntimed
                                    ?
                                        <div className='digitalACTModule__timer'>
                                            <div className='digitalACTModule__timerContainer'>
                                                <div className='digitalACTModule__timerTitle'>TOTAL TIME LEFT</div>
                                                <div className='digitalACTModule__timerContent'>
                                                    {hideTimer? '--:--:--' : formatTime(timeLeft)}
                                                </div>
                                            </div>
                                            {hideTimer
                                                ? <IoEyeOutline className='digitalACTModule__timerIcon' onClick={() => setHideTimer(!hideTimer)}/>
                                                : <IoEyeOffOutline className='digitalACTModule__timerIcon' onClick={() => setHideTimer(!hideTimer)}/>
                                            }
                                        </div>
                                    : 
                                        <div className='digitalACTModule__timer'>
                                            <MdOutlineTimerOff />
                                        </div>
                                    }
                                    <div className='digitalACTModule__endTest' onClick={() => {}}>
                                        <RiStopCircleLine className='digitalACTModule__endTestIcon'/>
                                        <div className='digitalACTModule__endTestContent' onClick={() => {manageExit(!exitOpen)}}>END TEST</div>
                                    </div>
                                </div>
                            </div>


                            {/* body */}
                            <div className='digitalACTModule__body'>
                                <div className='digitalACTModule__bodyMain'>
                                    {/* body-testModule */}
                                    <div className={indexOpen? 'digitalACTModule__testModule--open': 'digitalACTModule__testModule'}>
                                        {/* calculator */}
                                        <div id='calculatorDrag2' className={toolsSelected.includes('Scientific Calculator')
                                            ? 'digitalACTModule__popup--calculator draggable-element'
                                            : 'digitalACTModule__popup--hidden'
                                        }>
                                            <div className='digitalACTModule__popupHeader'>
                                                <h3 className='digitalACTModule__popupHeaderText'>Scientific Calculator</h3>
                                                <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Scientific Calculator')} />
                                            </div>
                                            <div
                                                ref = {magnifierCalculatorRef}
                                                style={{ width: 400, height: 600 }}
                                            ></div>
                                        </div>
                                        {/* Line Reader*/}
                                        <div id='lineReaderDrag2' className={toolsSelected.includes('Line Reader')
                                            ? 'digitalACTModule__popup--lineReader draggable-element'
                                            : 'digitalACTModule__popup--hidden'
                                        }>
                                            <div className='digitalACTModule__popupHeader'>
                                                <h3 className='digitalACTModule__popupHeaderText'>Line Reader</h3>
                                                <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Line Reader')} />
                                            </div>
                                            <div className='digitalACTModule__popuplineReader'>
                                                <div className='digitalACTModule__lineReaderResize'>
                                                    <SiZenn />
                                                </div>
                                                <div id='digitalACTModule__popuplineReaderContent2' className='digitalACTModule__popuplineReaderContent'>
                                                    <div className='digitalACTModule__lineReaderIconContainer'>
                                                        <div className='digitalACTModule__lineReaderTransparentResize'>
                                                            <SiZenn />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Highlighter */}
                                        <div id='highlighterDrag2' className={toolsSelected.includes('Highlighter')
                                            ? 'digitalACTModule__popup--highlighter draggable-element'
                                            : 'digitalACTModule__popup--hidden'
                                        }>
                                            <div className='digitalACTModule__popupHeader'>
                                                <h3 className='digitalACTModule__popupHeaderText'>Highlighter</h3>
                                                <div className='digitalACTModule__popupHeaderIcons'>
                                                    <FiHelpCircle className='digitalACTModule__popupHeaderClose' onClick={() => setHighlighterExplOpen(!highlighterExplOpen)}/>
                                                    <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Highlighter')} />
                                                </div>
                                            </div>
                                            <div className='digitalACTModule__popupHighlighter'>
                                                <Button
                                                    className='digitalACTModule__testModule__Button'
                                                    onClick={() => setEditAble(!editAble)}
                                                    secondary={editAble ? undefined : true}
                                                >
                                                    EDIT
                                                </Button>
                                                <Button
                                                    className='digitalACTModule__testModule__Button'
                                                    secondary
                                                    onClick={()=> annotationDelete()}
                                                >
                                                    CLEAR
                                                </Button>
                                            </div>
                                            {highlighterExplOpen && 
                                                <div className='digitalACTModule__highlighterExpl'>
                                                    <div className='digitalACTModule__highlighterExplHeader'>Highlighter</div>
                                                    <div className='digitalACTModule__highlighterExplContentBox'>
                                                        <div className='digitalACTModule__highlighterExplContent'>Edit button should be active to apply highlights.</div>
                                                        {/* <div className='digitalACTModule__highlighterExplContent'>When using caret browsing, make a selection with SHIFT + Arrow keys to highlight text.</div> */}
                                                    </div>
                                                    <Button
                                                        className='digitalACTModule__highlighterExButton'
                                                        onClick={() => setHighlighterExplOpen(!highlighterExplOpen)}
                                                    >
                                                        OK
                                                    </Button>
                                                </div>
                                            }
                                        </div>

                                        {/* body-testModule-header */}
                                        <div className='digitalACTModule__testModule__header'>
                                            {direction?
                                                <div className='digitalACTModule__testModule__questionNum'>Information</div>
                                                : questionNumber === 0
                                                ? <div className='digitalACTModule__testModule__questionNum'>Instructions</div>
                                                :<div className='digitalACTModule__testModule__questionNum'>Item {questionNumber}</div>
                                            }
                                            {!direction&&
                                                (questionNumber === 0 ?
                                                    (instructionFlag?
                                                        <div className='digitalACTModule__testModule__flagContainer' onClick={()=>{setInstructionFlag(!instructionFlag)}}>
                                                            <FaBookmark className='digitalACTModule__testModule__flagIcon mark' />
                                                            <div className='mark'>FLAG</div>
                                                        </div>
                                                        :
                                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={()=>{setInstructionFlag(!instructionFlag)}}>
                                                            <FaRegBookmark className='digitalACTModule__testModule__flagIcon' />
                                                            <div>FLAG</div>
                                                        </div>
                                                    )
                                                    :
                                                    (answers[questionNumber-1].marked ? (
                                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={markQuestion}>
                                                            <FaBookmark className='digitalACTModule__testModule__flagIcon mark' />
                                                            <div className='mark'>FLAG</div>
                                                        </div>
                                                    ) : (
                                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={markQuestion}>
                                                            <FaRegBookmark className='digitalACTModule__testModule__flagIcon' />
                                                            <div>FLAG</div>
                                                        </div>
                                                    ))
                                                )
                                            }
                                        </div>
                                        <div className='digitalACTModule__dottedLine' />
                                        {/* body-testModule-body */}
                                        {questionNumber > 0?
                                            <div className='digitalACTModule__test'>
                                                {questions[questionNumber-1].passages && questions[questionNumber-1].choices.length > 0 &&
                                                    <>
                                                        <div className='digitalACTModule__material'
                                                            ref = {magnifierPassageContainerRef}
                                                        >
                                                            <div className='digitalACTModule__materialContent'>
                                                                {/* {questions[questionNumber-1].figures.map(figure => (
                                                                    <img
                                                                        className='digitalACTModule__figure'
                                                                        key={figure.id}
                                                                        src={figure.image}
                                                                        alt={(questionNumber).toString()}
                                                                    />
                                                                ))} */}
                                                                
                                                                <div key={questions[questionNumber-1].passages.id} className='digitalACTModule__passage'>
                                                                    {/* 해당 id를 가진 passage의 p태그 가져와서 highlight 넣은 html 받아와서 겹쳐 보여줌 (z-index, transparent 조절) */}
                                                                    {/*figure 없는 페시지 가져와서-> fullPassage (getPassageWithFigure), highlighting(generateHighlightIndexing)-> 그 페시지로 annotation-> */}
                                                                    <p
                                                                        id={`magnifier ${passages.id}`}
                                                                        className={editAble && toolsSelected.includes('Highlighter')
                                                                            ? 'katex digitalACTModule__passageText'
                                                                            : 'katex digitalACTModule__passageText--blocked'
                                                                        }
                                                                    >
                                                                        {questions[questionNumber-1].passages.passage}
                                                                    </p>
                                                                    <p
                                                                        id={`passage ${questions[questionNumber-1].passages.id}`}
                                                                        className={editAble && toolsSelected.includes('Highlighter')
                                                                            ? 'katex digitalACTModule__passageTextPassage'
                                                                            : 'katex digitalACTModule__passageTextPassage--blocked'
                                                                        }
                                                                        onMouseUp={(editAble && toolsSelected.includes('Highlighter')) ? selectAnnotation : undefined}    
                                                                        onTouchEnd={(editAble && toolsSelected.includes('Highlighter')) ? selectAnnotation : undefined}
                                                                        dangerouslySetInnerHTML={{ __html: fullPassage?.html }}
                                                                    >
                                                                    </p>
                                                                    {/* highlight indexing */}
                                                                    {questionNumber > 0 && 
                                                                        highlighting.map((highlight, index)=>
                                                                            <div
                                                                                id={`magnifierHighlighting ${questions[questionNumber-1].passages.id}`}
                                                                                key={index}
                                                                                className='katex digitalACTModule__Highlight'
                                                                                dangerouslySetInnerHTML={{ __html: highlight?.html }}
                                                                            ></div>
                                                                        )
                                                                    }
                                                                    {/* annotation */}
                                                                    {toolsSelected.includes('Highlighter') &&
                                                                        answers[questionNumber-1].annotations.filter(annotation => (
                                                                            annotation.passageId === `passage ${questions[questionNumber-1].passages.id}`
                                                                        )).map((annotation, a) => <>
                                                                            <div
                                                                                className='katex digitalACTModule__passageAnnotation'
                                                                                dangerouslySetInnerHTML={{ __html: annotation.html }}
                                                                            ></div>
                                                                        </>)
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='digitalACTModule__verticalLine'></div>
                                                    </>
                                                }
                                                <div className='digitalACTModule__question' ref = {magnifierQuestionContainerRef}>
                                                    <div className='digitalACTModule__questionContent'>
                                                        <span className='katex digialACTModule__questionQuestion'>
                                                            {questions[questionNumber-1].question}
                                                        </span>
                                                        {questions[questionNumber-1].figures.map(figure => (
                                                            <img
                                                                className='digitalACTModule__figure'
                                                                key={figure.id}
                                                                src={figure.image}
                                                                alt={(questionNumber).toString()}
                                                            />
                                                        ))}
                                                    </div>
                                                    <div className='digitalACTModule__questionChoiceContainer'>
                                                        {questions[questionNumber-1].choices.length &&   
                                                            <>
                                                                {questions[questionNumber-1].choices.map((choice, i) => (
                                                                    <div key={choice.id}  
                                                                        className='digitalACTModule__questionChoiceWrapper'
                                                                    >
                                                                        <div 
                                                                            className='digitalACTModule__choiceContainer'
                                                                            onClick={() => {
                                                                                if ((toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))) return;
                                                                                handleSelect(choice.id);
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                                    ? 'digitalACTModule__radioButton--disabled' 
                                                                                    : answers[questionNumber-1].answer === choice.id
                                                                                    ? 'digitalACTModule__radioButton--selected'
                                                                                    : 'digitalACTModule__radioButton'
                                                                                }>
                                                                                    {answers[questionNumber-1].answer === choice.id?
                                                                                        <IoMdRadioButtonOn className='digitalACTModule__radioButtonIcon'/>
                                                                                        : <IoMdRadioButtonOff className='digitalACTModule__radioButtonIcon'/>
                                                                                    }
                                                                            </div>
                                                                            <div className={answers[questionNumber-1].answer === choice.id?
                                                                                'digitalACTModule__questionChoiceContent--selected'
                                                                                : (toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                                ? 'digitalACTModule__questionChoiceContent--disabled' 
                                                                                : 'digitalACTModule__questionChoiceContent'
                                                                            }>
                                                                                {/* crossout */}
                                                                                {toolsSelected.includes('Answer Eliminator') && answers[questionNumber-1].crossedOut.includes(choice.id) && (
                                                                                    <div className="digitalACTModule__crossOutLine"></div>
                                                                                )}
                                                                                {/* masking */}
                                                                                {toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id) && (
                                                                                    <div className="digitalACTModule__maskingBox"></div>
                                                                                )}
                                                                                <p className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                                    ? 'digitalACTModule__choiceText--disabled' 
                                                                                    : 'digitalACTModule__choiceText'
                                                                                }>
                                                                                    {MULTIPLE_CHOICES[i]}.
                                                                                </p>
                                                                                {choice.figure
                                                                                ?   <img
                                                                                        className='digitalACTModule__questionChoiceFigure'
                                                                                        key={choice.figure}
                                                                                        src={choice.figure}
                                                                                        alt={choice.figure}
                                                                                    />
                                                                                :   <p className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                                    ? 'digitalACTModule__questionChoiceText--disabled' 
                                                                                    : 'digitalACTModule__questionChoiceText'
                                                                                    }>
                                                                                        <span className='katex'>
                                                                                            {choice.choice}
                                                                                        </span>
                                                                                    </p>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='digitalACTModule__toolsContainer'>
                                                                            {toolsSelected.includes('Answer Eliminator') &&
                                                                                <button 
                                                                                    className={answers[questionNumber-1].crossedOut.includes(choice.id)
                                                                                    ? 'digitalACTModule__crossOut--selected'
                                                                                    : 'digitalACTModule__crossOut'
                                                                                    }
                                                                                    onClick={() => crossOutChoice(choice.id)}
                                                                                >
                                                                                    <FaXmark className='digitalACTModule__crossOutIcon'/>
                                                                                </button>
                                                                            }
                                                                            {toolsSelected.includes('Answer Masking') &&
                                                                                <button 
                                                                                    className={answers[questionNumber-1].masking.includes(choice.id)
                                                                                        ? 'digitalACTModule__masking--selected'
                                                                                        : 'digitalACTModule__masking'
                                                                                        }
                                                                                    onClick={() => maskingChoice(choice.id)}
                                                                                >
                                                                                    {answers[questionNumber-1].masking.includes(choice.id)
                                                                                        ? <IoEyeOffOutline className='digitalACTModule__maskingIcon'/>
                                                                                        : <IoEyeOutline className='digitalACTModule__maskingIcon'/>
                                                                                    }
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            : direction?
                                                <DigitalACTDirection
                                                    subject={subject}
                                                />
                                            :
                                            <div className='digitalACTModule__instruction'>
                                                <p className='katex'>
                                                    {prompt
                                                        ? prompt
                                                        : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sollicitudin, mi congue condimentum dignissim, ipsum diam tristique velit, et rutrum orci massa non purus. Etiam vitae ante sed velit blandit condimentum. Donec lectus ipsum, volutpat vel tortor a, blandit elementum felis. Mauris a ultricies quam, at molestie ipsum. Cras nec ante justo. Suspendisse egestas lectus sit amet sem maximus auctor. In ut dignissim lorem, ac tristique eros. Nullam eget sollicitudin quam. Quisque pellentesque cursus justo sed ornare. Integer finibus, tortor at facilisis molestie, ligula augue cursus ipsum, eget auctor enim sem a eros. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Pellentesque suscipit, nunc eget mollis consequat, augue odio suscipit enim, vel varius eros leo sit amet magna. Nunc suscipit leo et metus bibendum, a finibus libero finibus. In lacinia scelerisque urna ut pretium. In at est aliquam, dictum odio non, fringilla tellus. Vivamus commodo molestie urna at dapibus. Nulla facilisi. Maecenas sit amet lorem tincidunt, maximus nunc eu, malesuada velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla facilisi.'
                                                    }
                                                </p>
                                            </div>
                                        }

                                        {/* body-testModule-footer */}
                                        <div className='digitalACTModule__dottedLine2' />
                                        <div className='digitalACTModule__testModule__footer'>
                                            <div className='digitalACTModule__testModule__footerButtons'>
                                                <Button
                                                    className='digitalACTModule__testModule__Button'
                                                    secondary
                                                    disabled={questionNumber === 0}
                                                    onClick={() => goToQuestion(questionNumber - 1)}
                                                >
                                                    BACK
                                                </Button>
                                                <Button
                                                    className='digitalACTModule__testModule__Button'
                                                    onClick={() => direction
                                                        ? beginTest()
                                                        : questionNumber >= questions.length
                                                        ? handleSubmit()
                                                        : goToQuestion(questionNumber + 1)
                                                    }
                                                >
                                                    {questionNumber >= questions.length ? 'SUBMIT' : 'NEXT'}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* body-index */}
                                    {indexOpen &&
                                        <>
                                            {/* <div 
                                                className='digitalACTModule__verticalLine2'
                                                onMouseDown={handleMouseDown}
                                                onMouseMove={handleMouseMove}
                                                onMouseUp={handleMouseUp}
                                                onMouseLeave={handleMouseUp} 
                                            /> */}
                                            <div className='digitalACTModule__indexContainer'>
                                                <div className='digitalACTModule__indexHeader'>
                                                    <div className='digitalACTModule__indexHeaderContainer'>
                                                        <RiFilter2Line className='digitalACTModule__indexHeaderIcon'/>
                                                        <div className='digitalACTModule__indexHeaderTitle'>Filter By</div>
                                                    </div>
                                                    <div className='digitalACTModule__indexHeaderFilter'>
                                                        <Dropdown4
                                                            value={indexFilterSelected}
                                                            data={indexFilter} 
                                                            instruction={instructionFlag}
                                                            onSelect={(value) => setIndexFilterSelected(value)}
                                                            isOpen={isFilterOpen}
                                                        />
                                                    </div>
                                                </div>
                                                <div 
                                                    className='digitalACTModule__indexContentContainer'
                                                    ref={magnifierIndexContainerRef}
                                                >
                                                    {/* {(indexFilterSelected === 'All questions') && */}
                                                    {(indexFilterSelected === 'All questions' || indexFilterSelected ==='Flagged' && instructionFlag) &&
                                                        <div 
                                                            className='digitalACTModule__indexBox' 
                                                            ref={(el) => magnifierQuestionRefs.current[0] = el} 
                                                        >
                                                            <div className={questionNumber==0
                                                                    ? 'digitalACTModule__indexBoxHeader--current'
                                                                    : 'digitalACTModule__indexBoxHeader'
                                                                }
                                                            >
                                                                {instructionFlag &&
                                                                    <FaBookmark className='mark'/>
                                                                }
                                                                <div className='digitalACTModule__indexBoxHeaderQuestionNumber'>Instructions</div>
                                                            </div>
                                                            <div className='digitalACTModule__indexBoxBody' onClick={()=> navigateQuestion(0)}>
                                                                <div className='digitalACTModule__indexBoxBodyQuestionIns'>
                                                                    <span className='katex'>
                                                                        {prompt
                                                                            // .replaceAll('$\\ \\ \\\\$', '') // no enter space
                                                                            // .replaceAll('$\\\\ \\, \\\\ $', '') // no enter space
                                                                            // .replaceAll('$\\\\ \\ \\\\$', '') // no enter space
                                                                            // .replaceAll('$\\\\$', '') // no enter space
                                                                            // .replaceAll('$\\qquad$', '') // no $\qquad$
                                                                            // .replaceAll(/\$\$(.*?)\$\$/g, (_, match) => `$${match}$`)
                                                                            .replace(/\\\s*\,\s*\\/g, ' ') // `\ , \` 형태의 공백을 하나의 스페이스로 변환
                                                                            .replace(/\$[^$]+\$/g, ' ') // `$...$` 제거
                                                                            .trim() // 앞뒤 공백 제거
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {filteredQuestions.map((question, i) => {
                                                        const answer = answers.find(a => a.questionId === question.id);
                                                        return (
                                                            <div 
                                                                key={question.questionNum}
                                                                className='digitalACTModule__indexBox'
                                                                ref={(el) => magnifierQuestionRefs.current[question.questionNum] = el} 
                                                            >
                                                                <div className={questionNumber==question.questionNum
                                                                        ? 'digitalACTModule__indexBoxHeader--current'
                                                                        : 'digitalACTModule__indexBoxHeader'
                                                                    }
                                                                >
                                                                    {answer?.marked &&
                                                                        <FaBookmark className='mark'/>
                                                                    }
                                                                    <div className='digitalACTModule__indexBoxHeaderQuestionNumber'>ITEM {question.questionNum}</div>
                                                                </div>
                                                                <div className='digitalACTModule__indexBoxBody' onClick={()=> navigateQuestion(question.questionNum)}>
                                                                    <div className='digitalACTModule__indexBoxBodyQuestion'>
                                                                        <span className='katex'>
                                                                            {question.question
                                                                                .replaceAll('$\\ \\ \\\\$', '') // no enter space
                                                                                .replaceAll('$\\\\ \\, \\\\ $', '') // no enter space
                                                                                .replaceAll('$\\\\ \\ \\\\$', '') // no enter space
                                                                                .replaceAll('$\\\\$', '') // no enter space
                                                                                .replaceAll('$\\qquad$', '') // no $\qquad$
                                                                                .replaceAll(/\$\$(.*?)\$\$/g, (_, match) => `$${match}$`)
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                    {(answer?.answer!=='' && answer?.answer!==null) &&
                                                                        <div className='digitalACTModule__indexBoxBodyQuestionAnswered'>
                                                                            <div className='digitalACTModule__indexAnsweredTitle'>ANSWERED</div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </>
                                    }

                                </div>

                                {/* body-rightBar */}
                                <div className='digitalACTModule__rightBar'>
                                    <div 
                                        className={indexOpen
                                            ? 'digitalACTModule__rightBarContainer--selected' 
                                            : 'digitalACTModule__rightBarContainer' 
                                        }
                                        onClick={() => {setIndexOpen(!indexOpen)}}
                                    >
                                        <IoMenu className='digitalACTModule__rightBarIcon'/>
                                        <div className='digitalACTModule__rightBarTitle'>INDEX</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div 
                    id='digitalACTModule__magnifierResize'
                    className='digitalACTModule__magnifierResize'
                >
                    <SiZenn/>
                </div>
            </div>
            {/* header */}
            <div className='digitalACTModule__header'>
                {/* header - left */}
                <div className='digitalACTModule__title'>
                    <div className='digitalACTModule__titleContent'>{testName}</div>
                    {/* <img 
                        className='digitalACTModule__logo'
                        src={logo} 
                    /> */}
                </div>
                {/* header - middle */}
                <div className='digitalACTModule__actionGroup'>
                    <Dropdown3 
                        className='digitalACTModule__dropdown3'
                        icon={<FaTools />}
                        data={tools} 
                        selectedItems={toolsSelected}
                        onSelect={(value)=> handleTools(value)}
                        value='TOOLS'
                        // disabled={questionNumber <= 0}
                        isOpen={isToolsOpen}
                        setIsOpen={setIsToolsOpen}
                    />
                    {/* <Dropdown3 
                        className='digitalACTModule__dropdown3'
                        icon={<FaTools />}
                        data={tools} 
                        selectedItems={toolsSelected}
                        onSelect={(value)=> handleTools(value)}
                        value='CONTRAST'
                        isOpen={isFilterOpen}
                        setIsOpen={setIsFilterOpen}
                    /> */}
                </div>
                {/* header - right */}
                <div className='digitalACTModule__testInfoGroup'>
                    <div className='digitalACTModule__answerInfo'>
                        <div className='digitalACTModule__answerTitle'>ANSWERED</div>
                        <div className='digitalACTModule__answerContent'>{indexFilter['Answered']} out of {questions.length}</div>
                    </div>
                    {!isUntimed
                    ?
                        <div className='digitalACTModule__timer'>
                            <div className='digitalACTModule__timerContainer'>
                                <div className='digitalACTModule__timerTitle'>TOTAL TIME LEFT</div>
                                <div className='digitalACTModule__timerContent'>
                                    {hideTimer? '--:--:--' : formatTime(timeLeft)}
                                </div>
                            </div>
                            {hideTimer
                                ? <IoEyeOutline className='digitalACTModule__timerIcon' onClick={() => setHideTimer(!hideTimer)}/>
                                : <IoEyeOffOutline className='digitalACTModule__timerIcon' onClick={() => setHideTimer(!hideTimer)}/>
                            }
                        </div>
                    : 
                        <div className='digitalACTModule__timer'>
                            <MdOutlineTimerOff />
                        </div>
                    }
                    <div className='digitalACTModule__endTest' onClick={() => {}}>
                        <RiStopCircleLine className='digitalACTModule__endTestIcon'/>
                        <div className='digitalACTModule__endTestContent' onClick={() => {manageExit(!exitOpen)}}>END TEST</div>
                    </div>
                </div>
            </div>


            {/* body */}
            <div className='digitalACTModule__body'>
                <div className='digitalACTModule__bodyMain'>
                    {/* body-testModule */}
                    <div id ='digitalACTModule__testModule' className={indexOpen? 'digitalACTModule__testModule--open': 'digitalACTModule__testModule'}>
                        {/* calculator */}
                        <div id='calculatorDrag' className={toolsSelected.includes('Scientific Calculator')
                            ? 'digitalACTModule__popup--calculator draggable-element'
                            : 'digitalACTModule__popup--hidden'
                        }>
                            <div id='calculatorHeader' className='digitalACTModule__popupHeader'>
                                <h3 className='digitalACTModule__popupHeaderText'>Scientific Calculator</h3>
                                <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Scientific Calculator')} />
                            </div>
                            <div
                                id='calculator'
                                style={{ width: 400, height: 600 }}
                            ></div>
                        </div>
                        {/* Line Reader*/}
                        <div id='lineReaderDrag' className={toolsSelected.includes('Line Reader')
                            ? 'digitalACTModule__popup--lineReader draggable-element'
                            : 'digitalACTModule__popup--hidden'
                        }>
                            <div id='lineReaderHeader' className='digitalACTModule__popupHeader'>
                                <h3 className='digitalACTModule__popupHeaderText'>Line Reader</h3>
                                <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Line Reader')} />
                            </div>
                            <div className='digitalACTModule__popuplineReader'>
                                <div id='digitalACTModule__lineReaderResize' className='digitalACTModule__lineReaderResize'>
                                    <SiZenn />
                                </div>
                                <div id='digitalACTModule__popuplineReaderContent' className='digitalACTModule__popuplineReaderContent'>
                                    <div className='digitalACTModule__lineReaderIconContainer'>
                                        <div id='digitalACTModule__lineReaderTransparentResize' className='digitalACTModule__lineReaderTransparentResize'>
                                            <SiZenn />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Highlighter */}
                        <div id='highlighterDrag' className={toolsSelected.includes('Highlighter')
                            ? 'digitalACTModule__popup--highlighter draggable-element'
                            : 'digitalACTModule__popup--hidden'
                        }>
                            <div id='highlighterHeader' className='digitalACTModule__popupHeader'>
                                <h3 className='digitalACTModule__popupHeaderText'>Highlighter</h3>
                                <div className='digitalACTModule__popupHeaderIcons'>
                                    <FiHelpCircle className='digitalACTModule__popupHeaderClose' onClick={() => setHighlighterExplOpen(!highlighterExplOpen)}/>
                                    <MdClose className='digitalACTModule__popupHeaderClose' onClick={() => handleTools('Highlighter')} />
                                </div>
                            </div>
                            <div className='digitalACTModule__popupHighlighter'>
                                <Button
                                    className='digitalACTModule__testModule__Button'
                                    onClick={() => setEditAble(!editAble)}
                                    secondary={editAble ? undefined : true}
                                >
                                    EDIT
                                </Button>
                                <Button
                                    className='digitalACTModule__testModule__Button'
                                    secondary
                                    onClick={()=> annotationDelete()}
                                >
                                    CLEAR
                                </Button>
                            </div>
                            {highlighterExplOpen && 
                                <div className='digitalACTModule__highlighterExpl'>
                                    <div className='digitalACTModule__highlighterExplHeader'>Highlighter</div>
                                    <div className='digitalACTModule__highlighterExplContentBox'>
                                        <div className='digitalACTModule__highlighterExplContent'>Edit button should be active to apply highlights.</div>
                                        <div className='digitalACTModule__highlighterExplContent'>When using caret browsing, make a selection with SHIFT + Arrow keys to highlight text.</div>
                                    </div>
                                    <Button
                                        className='digitalACTModule__highlighterExButton'
                                        onClick={() => setHighlighterExplOpen(!highlighterExplOpen)}
                                    >
                                        OK
                                    </Button>
                                </div>
                            }
                        </div>

                        {/* body-testModule-header */}
                        <div className='digitalACTModule__testModule__header'>
                            {direction?
                                <div className='digitalACTModule__testModule__questionNum'>Information</div>
                                : questionNumber === 0
                                ? <div className='digitalACTModule__testModule__questionNum'>Instructions</div>
                                :<div className='digitalACTModule__testModule__questionNum'>Item {questionNumber}</div>
                            }
                            {!direction&&
                                (questionNumber === 0 ?
                                    (instructionFlag?
                                        <div className='digitalACTModule__testModule__flagContainer' onClick={()=>{setInstructionFlag(!instructionFlag)}}>
                                            <FaBookmark className='digitalACTModule__testModule__flagIcon mark' />
                                            <div className='mark'>FLAG</div>
                                        </div>
                                        :
                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={()=>{setInstructionFlag(!instructionFlag)}}>
                                            <FaRegBookmark className='digitalACTModule__testModule__flagIcon' />
                                            <div>FLAG</div>
                                        </div>
                                    )
                                    :
                                    (answers[questionNumber-1].marked ? (
                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={markQuestion}>
                                            <FaBookmark className='digitalACTModule__testModule__flagIcon mark' />
                                            <div className='mark'>FLAG</div>
                                        </div>
                                    ) : (
                                        <div  className='digitalACTModule__testModule__flagContainer' onClick={markQuestion}>
                                            <FaRegBookmark className='digitalACTModule__testModule__flagIcon' />
                                            <div>FLAG</div>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                        <div className='digitalACTModule__dottedLine' />
                        {/* body-testModule-body */}
                        {questionNumber > 0?
                            <div className='digitalACTModule__test'>
                                {questions[questionNumber-1].passages && questions[questionNumber-1].choices.length > 0 &&
                                    <>
                                        <div className='digitalACTModule__material'
                                            ref = {passageContainerRef}
                                        >
                                            <div className='digitalACTModule__materialContent'>
                                                {/* {questions[questionNumber-1].figures.map(figure => (
                                                    <img
                                                        className='digitalACTModule__figure'
                                                        key={figure.id}
                                                        src={figure.image}
                                                        alt={(questionNumber).toString()}
                                                    />
                                                ))} */}
                                                <div key={questions[questionNumber-1].passages.id} className='digitalACTModule__passage'>
                                                    {/* 해당 id를 가진 passage의 p태그 가져와서 highlight 넣은 html 받아와서 겹쳐 보여줌 (z-index, transparent 조절) */}
                                                    <p
                                                        id={questions[questionNumber-1].passages.id}
                                                        className={editAble && toolsSelected.includes('Highlighter')
                                                            ? 'katex digitalACTModule__passageText'
                                                            : 'katex digitalACTModule__passageText--blocked'
                                                        }
                                                        ref={passageRef}
                                                    >
                                                        {questions[questionNumber-1].passages.passage}
                                                    </p>
                                                    <p
                                                        id={`passage ${questions[questionNumber-1].passages.id}`}
                                                        className={editAble && toolsSelected.includes('Highlighter')
                                                            ? 'katex digitalACTModule__passageTextPassage'
                                                            : 'katex digitalACTModule__passageTextPassage--blocked'
                                                        }
                                                        onMouseUp={(editAble && toolsSelected.includes('Highlighter')) ? selectAnnotation : undefined}    
                                                        onTouchEnd={(editAble && toolsSelected.includes('Highlighter')) ? selectAnnotation : undefined}
                                                        dangerouslySetInnerHTML={{ __html: fullPassage?.html }}
                                                    >
                                                    </p>
                                                    {questionNumber > 0 && 
                                                        highlighting.map((highlight, index)=>
                                                            <div
                                                                id={`highlighting ${questions[questionNumber-1].passages.id}`}
                                                                key={index}
                                                                className='katex digitalACTModule__Highlight'
                                                                dangerouslySetInnerHTML={{ __html: highlight?.html }}
                                                            ></div>
                                                        )
                                        
                                                    }
                                                    {toolsSelected.includes('Highlighter') &&
                                                        answers[questionNumber-1].annotations.filter(annotation => (
                                                            annotation.passageId === `passage ${questions[questionNumber-1].passages.id}`
                                                        )).map((annotation, a) => <>
                                                            <div
                                                                className='katex digitalACTModule__passageAnnotation'
                                                                dangerouslySetInnerHTML={{ __html: annotation.html }}
                                                            ></div>
                                                        </>)
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='digitalACTModule__verticalLine'></div>
                                    </>
                                }
                                <div className='digitalACTModule__question' ref = {questionContainerRef}>
                                    <div className='digitalACTModule__questionContent'>
                                        <span className='katex digialACTModule__questionQuestion'>
                                            {questions[questionNumber-1].question}
                                        </span>
                                        {questions[questionNumber-1].figures.map(figure => (
                                            <img
                                                className='digitalACTModule__figure'
                                                key={figure.id}
                                                src={figure.image}
                                                alt={(questionNumber).toString()}
                                            />
                                        ))}
                                    </div>
                                    <div className='digitalACTModule__questionChoiceContainer'>
                                        {questions[questionNumber-1].choices.length &&   
                                            <>
                                                {questions[questionNumber-1].choices.map((choice, i) => (
                                                    <div key={choice.id}  
                                                        className='digitalACTModule__questionChoiceWrapper'
                                                    >
                                                        <div 
                                                            className='digitalACTModule__choiceContainer'
                                                            onClick={() => {
                                                                if ((toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))) return;
                                                                handleSelect(choice.id);
                                                            }}
                                                        >
                                                            <div
                                                                className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                    ? 'digitalACTModule__radioButton--disabled' 
                                                                    : answers[questionNumber-1].answer === choice.id
                                                                    ? 'digitalACTModule__radioButton--selected'
                                                                    : 'digitalACTModule__radioButton'
                                                                }>
                                                                    {answers[questionNumber-1].answer === choice.id?
                                                                        <IoMdRadioButtonOn className='digitalACTModule__radioButtonIcon'/>
                                                                        : <IoMdRadioButtonOff className='digitalACTModule__radioButtonIcon'/>
                                                                    }
                                                            </div>
                                                            <div className={answers[questionNumber-1].answer === choice.id?
                                                                'digitalACTModule__questionChoiceContent--selected'
                                                                : (toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                ? 'digitalACTModule__questionChoiceContent--disabled' 
                                                                : 'digitalACTModule__questionChoiceContent'
                                                            }>
                                                                {/* crossout */}
                                                                {toolsSelected.includes('Answer Eliminator') && answers[questionNumber-1].crossedOut.includes(choice.id) && (
                                                                    <div className="digitalACTModule__crossOutLine"></div>
                                                                )}
                                                                {/* masking */}
                                                                {toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id) && (
                                                                    <div className="digitalACTModule__maskingBox"></div>
                                                                )}
                                                                <p className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                    ? 'digitalACTModule__choiceText--disabled' 
                                                                    : 'digitalACTModule__choiceText'
                                                                }>
                                                                    {MULTIPLE_CHOICES[i]}.
                                                                </p>
                                                                {choice.figure
                                                                ?   <img
                                                                        className='digitalACTModule__questionChoiceFigure'
                                                                        key={choice.figure}
                                                                        src={choice.figure}
                                                                        alt={choice.figure}
                                                                    />
                                                                :   <p className={(toolsSelected.includes('Answer Eliminator') && (answers[questionNumber-1].crossedOut.includes(choice.id))) || (toolsSelected.includes('Answer Masking') && answers[questionNumber-1].masking.includes(choice.id))
                                                                    ? 'digitalACTModule__questionChoiceText--disabled' 
                                                                    : 'digitalACTModule__questionChoiceText'
                                                                    }>
                                                                        <span className='katex'>
                                                                            {choice.choice}
                                                                        </span>
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='digitalACTModule__toolsContainer'>
                                                            {toolsSelected.includes('Answer Eliminator') &&
                                                                <button 
                                                                    className={answers[questionNumber-1].crossedOut.includes(choice.id)
                                                                    ? 'digitalACTModule__crossOut--selected'
                                                                    : 'digitalACTModule__crossOut'
                                                                    }
                                                                    onClick={() => crossOutChoice(choice.id)}
                                                                >
                                                                    <FaXmark className='digitalACTModule__crossOutIcon'/>
                                                                </button>
                                                            }
                                                            {toolsSelected.includes('Answer Masking') &&
                                                                <button 
                                                                    className={answers[questionNumber-1].masking.includes(choice.id)
                                                                        ? 'digitalACTModule__masking--selected'
                                                                        : 'digitalACTModule__masking'
                                                                        }
                                                                    onClick={() => maskingChoice(choice.id)}
                                                                >
                                                                    {answers[questionNumber-1].masking.includes(choice.id)
                                                                        ? <IoEyeOffOutline className='digitalACTModule__maskingIcon'/>
                                                                        : <IoEyeOutline className='digitalACTModule__maskingIcon'/>
                                                                    }
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            : direction?
                                <DigitalACTDirection
                                    subject={subject}
                                />
                            :
                            <div className='digitalACTModule__instruction'>
                                <p className='katex'>
                                    {prompt
                                        ? prompt
                                        : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sollicitudin, mi congue condimentum dignissim, ipsum diam tristique velit, et rutrum orci massa non purus. Etiam vitae ante sed velit blandit condimentum. Donec lectus ipsum, volutpat vel tortor a, blandit elementum felis. Mauris a ultricies quam, at molestie ipsum. Cras nec ante justo. Suspendisse egestas lectus sit amet sem maximus auctor. In ut dignissim lorem, ac tristique eros. Nullam eget sollicitudin quam. Quisque pellentesque cursus justo sed ornare. Integer finibus, tortor at facilisis molestie, ligula augue cursus ipsum, eget auctor enim sem a eros. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Pellentesque suscipit, nunc eget mollis consequat, augue odio suscipit enim, vel varius eros leo sit amet magna. Nunc suscipit leo et metus bibendum, a finibus libero finibus. In lacinia scelerisque urna ut pretium. In at est aliquam, dictum odio non, fringilla tellus. Vivamus commodo molestie urna at dapibus. Nulla facilisi. Maecenas sit amet lorem tincidunt, maximus nunc eu, malesuada velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla facilisi.'
                                    }
                                </p>
                            </div>
                        }

                        {/* body-testModule-footer */}
                        <div className='digitalACTModule__dottedLine2' />
                        <div className='digitalACTModule__testModule__footer'>
                            <div className='digitalACTModule__testModule__footerButtons'>
                                <Button
                                    className='digitalACTModule__testModule__Button'
                                    secondary
                                    disabled={questionNumber === 0}
                                    onClick={() => goToQuestion(questionNumber - 1)}
                                >
                                    BACK
                                </Button>
                                <Button
                                    className='digitalACTModule__testModule__Button'
                                    onClick={() => direction
                                        ? beginTest()
                                        : questionNumber >= questions.length
                                        ? handleSubmit()
                                        : goToQuestion(questionNumber + 1)
                                    }
                                >
                                    {questionNumber >= questions.length ? 'SUBMIT' : 'NEXT'}
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* body-index */}
                    {indexOpen &&
                        <>
                            {/* <div 
                                className='digitalACTModule__verticalLine2'
                                onMouseDown={handleMouseDown}
                                onMouseMove={handleMouseMove}
                                onMouseUp={handleMouseUp}
                                onMouseLeave={handleMouseUp} 
                            /> */}
                            <div className='digitalACTModule__indexContainer'>
                                <div className='digitalACTModule__indexHeader'>
                                    <div className='digitalACTModule__indexHeaderContainer'>
                                        <RiFilter2Line className='digitalACTModule__indexHeaderIcon'/>
                                        <div className='digitalACTModule__indexHeaderTitle'>Filter By</div>
                                    </div>
                                    <div className='digitalACTModule__indexHeaderFilter'>
                                        <Dropdown4 
                                            value={indexFilterSelected}
                                            data={indexFilter} 
                                            instruction={instructionFlag}
                                            onSelect={(value) => setIndexFilterSelected(value)}
                                            isOpen={isFilterOpen}
                                            setIsOpen={setIsFilterOpen}
                                        />
                                    </div>
                                </div>
                                <div 
                                    className='digitalACTModule__indexContentContainer'
                                    ref={indexContainerRef}
                                >
                                    {/* {(indexFilterSelected === 'All questions') && */}
                                    {(indexFilterSelected === 'All questions' || indexFilterSelected ==='Flagged' && instructionFlag) &&
                                        <div 
                                            className='digitalACTModule__indexBox' 
                                            ref={(el) => questionRefs.current[0] = el} 
                                        >
                                            <div className={questionNumber==0
                                                    ? 'digitalACTModule__indexBoxHeader--current'
                                                    : 'digitalACTModule__indexBoxHeader'
                                                }
                                            >
                                                {instructionFlag &&
                                                    <FaBookmark className='mark'/>
                                                }
                                                <div className='digitalACTModule__indexBoxHeaderQuestionNumber'>Instructions</div>
                                            </div>
                                            <div className='digitalACTModule__indexBoxBody' onClick={()=> navigateQuestion(0)}>
                                                <div className='digitalACTModule__indexBoxBodyQuestionIns'>
                                                    <span className='katex'>
                                                        {prompt
                                                            // .replaceAll('$\\ \\ \\\\$', '') // no enter space
                                                            // .replaceAll('$\\\\ \\, \\\\ $', '') // no enter space
                                                            // .replaceAll('$\\\\ \\ \\\\$', '') // no enter space
                                                            // .replaceAll('$\\\\$', '') // no enter space
                                                            // .replaceAll('$\\qquad$', '') // no $\qquad$
                                                            // .replaceAll(/\$\$(.*?)\$\$/g, (_, match) => `$${match}$`)
                                                            .replace(/\\\s*\,\s*\\/g, ' ') // `\ , \` 형태의 공백을 하나의 스페이스로 변환
                                                            .replace(/\$[^$]+\$/g, ' ') // `$...$` 제거
                                                            .trim() // 앞뒤 공백 제거
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {filteredQuestions.map((question, i) => {
                                        const answer = answers.find(a => a.questionId === question.id);
                                        return (
                                            <div 
                                                key={question.questionNum}
                                                className='digitalACTModule__indexBox'
                                                ref={(el) => questionRefs.current[question.questionNum] = el} 
                                            >
                                                <div className={questionNumber==question.questionNum
                                                        ? 'digitalACTModule__indexBoxHeader--current'
                                                        : 'digitalACTModule__indexBoxHeader'
                                                    }
                                                >
                                                    {answer?.marked &&
                                                        <FaBookmark className='mark'/>
                                                    }
                                                    <div className='digitalACTModule__indexBoxHeaderQuestionNumber'>ITEM {question.questionNum}</div>
                                                </div>
                                                <div className='digitalACTModule__indexBoxBody' onClick={()=> navigateQuestion(question.questionNum)}>
                                                    <div className='digitalACTModule__indexBoxBodyQuestion'>
                                                        <span className='katex'>
                                                            {question.question
                                                                .replaceAll('$\\ \\ \\\\$', '') // no enter space
                                                                .replaceAll('$\\\\ \\, \\\\ $', '') // no enter space
                                                                .replaceAll('$\\\\ \\ \\\\$', '') // no enter space
                                                                .replaceAll('$\\\\$', '') // no enter space
                                                                .replaceAll('$\\qquad$', '') // no $\qquad$
                                                                .replaceAll(/\$\$(.*?)\$\$/g, (_, match) => `$${match}$`)
                                                            }
                                                        </span>
                                                    </div>
                                                    {(answer?.answer!=='' && answer?.answer!==null) &&
                                                        <div className='digitalACTModule__indexBoxBodyQuestionAnswered'>
                                                            <div className='digitalACTModule__indexAnsweredTitle'>ANSWERED</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    }

                </div>

                {/* body-rightBar */}
                <div className='digitalACTModule__rightBar'>
                    <div 
                        className={indexOpen
                            ? 'digitalACTModule__rightBarContainer--selected' 
                            : 'digitalACTModule__rightBarContainer' 
                        }
                        onClick={() => {setIndexOpen(!indexOpen)}}
                    >
                        <IoMenu className='digitalACTModule__rightBarIcon'/>
                        <div className='digitalACTModule__rightBarTitle'>INDEX</div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default DigitalACTModule;